import { render, staticRenderFns } from "./wechatuser.vue?vue&type=template&id=c3fd5b12&"
import script from "./wechatuser.vue?vue&type=script&lang=ts&"
export * from "./wechatuser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "wechatuser.vue"
export default component.exports